import { RouteObject } from 'react-router';
import Authenticated from 'src/components/Authenticated';
import Callback from 'src/content/pages/Callback';
import ExtendedSidebarLayout from 'src/layouts/ExtendedSidebarLayout';
import { ProposalRoutes, vendorDashboardsRoutes,TemplateRoutes, MasterTemplateRoutes,PastProposalRoutes } from './paths';
import CollapsedSidebarLayout from 'src/layouts/CollapsedSidebarLayout';

const luRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Authenticated>
        <ExtendedSidebarLayout />
      </Authenticated>
    ),

    children: [
      {
        path: '/',
        children: vendorDashboardsRoutes
      }
    ]
  },
  {
    path: "",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "vendor/proposals",
        children: ProposalRoutes,
      },
      {
        path: "vendor/proposal",
        children: PastProposalRoutes,
      },
      {
        path: "vendor/template",
        children: TemplateRoutes,
      },
      {
        path: "vendor/mastertemplate",
        children: MasterTemplateRoutes,
      },
    ],
  },
  {
    path: '',
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    )
  },
  {
    path: 'callback',
    element: <Callback />
  }
];

export default luRoutes;
